import React from 'react';
import FilterSection from '@framework/ui/Organisms/Filters/components/FilterSection';
import FilterColumns from '@framework/ui/Organisms/Filters/components/FilterColumns';
import Radio, { RadioGroup } from '@dealroadshow/uikit-radio';
import filterStyles from '@framework/ui/Organisms/Filters/filters.module.scss';

interface IProps {
  items: any,
  sectionId: string,
  sectionTitle: string,
  isVisible: boolean,
  onSectionToggle: () => void,
  filterName: string,
  selectedValue: string,
  handleFilterUpdate: (filter: { [key in string]: string }) => void,
}

function Status(props: IProps) {
  const {
    sectionId,
    sectionTitle,
    isVisible,
    filterName,
    selectedValue,
  } = props;
  const children = props.items.map((status) => ({
    id: status.statusValue,
    label: status.statusName,
    disabled: !status.canChangeResponse,
  }));
  return (
    <FilterSection
      sectionId={ sectionId }
      headerComponent={ sectionTitle }
      isVisible={ isVisible }
      onSectionToggle={ props.onSectionToggle }
    >
      <RadioGroup
        name="status"
        selectedValue={ selectedValue }
        onChange={ (value) => props.handleFilterUpdate({ [filterName]: value }) }
      >
        <FilterColumns columnsCount={ 3 }>
          { children.map(({
            id,
            label,
            disabled,
          }) => (
            <Radio
              key={ id }
              dataTest={ label }
              label={ label }
              value={ id }
              name={ filterName }
              disabled={ disabled }
              className={ filterStyles.filterRadio }
            />
          )) }
        </FilterColumns>
      </RadioGroup>
    </FilterSection>
  );
}

export default Status;
